import { html } from 'lit';

export const iconChevron = html`
  <svg
    width="12"
    height="6"
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.28125 4.3125L5.25 0.3125C5.46875 0.125 5.71875 0 6 0C6.25 0 6.5 0.125 6.6875 0.3125L10.6562 4.3125C10.9375 4.59375 11.0312 5.03125 10.875 5.40625C10.7188 5.78125 10.375 6 9.96875 6H2C1.59375 6 1.21875 5.78125 1.0625 5.40625C0.90625 5.03125 1 4.59375 1.28125 4.3125Z"
      fill="currentColor"
    />
  </svg>
`;
